import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer = 0;
    const show = () => {
      setOpen(true);
      hideTimer = window.setTimeout(() => {
        setOpen(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  const minutesAgo = index * 7 % 23 + 2;
  return <AnimatePresence data-id="element-8" data-mp="163mpzd5zo90u">
      {open && !dismissed && <motion.div role="status" aria-live="polite" className="fixed left-3 right-3 top-3 z-50 sm:left-5 sm:right-auto sm:top-auto sm:bottom-28 sm:w-[340px]" initial={{
      opacity: 0,
      y: -12,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -12,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-9" data-mp="1164ou8y7qy3e">
          <div className="flex items-center gap-3 rounded-2xl border border-line bg-paper p-3 pr-9 shadow-[0_12px_32px_rgba(9,26,51,0.18)]" data-id="element-10" data-mp="ia4u4qdupgg4">
            <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-11" data-mp="s5om51panuzl" />
            <div className="min-w-0" data-id="element-12" data-mp="28joglx5desfg">
              <p className="text-sm leading-snug text-ink" data-id="element-13" data-mp="28imyj8pxt5o8">
                <strong data-id="element-14" data-mp="23kblkp4cif1s">{buyer.name}</strong> from <strong data-id="element-15" data-mp="23l3ji6lf0ov8">{buyer.country}</strong> just purchased the{" "}
                <strong data-id="element-16" data-mp="2anjldlrgmjag">Endo Blueprint™</strong>
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-17" data-mp="2fneapkvl70te">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-18" data-mp="2kmr4yqosfa60" />
                Instant access · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan" aria-label="Close notification" data-id="element-19" data-mp="2pl2gd5uqdsqc">
              <XIcon className="h-4 w-4" data-id="element-20" data-mp="26mpwoq6710gi" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}